import { createThemeCompiler } from '../../../utils';

export const listViewThemeCompiler = createThemeCompiler(({ palette, borderRadius, stroke, boxShadow }) => ({
    listView: {
        colors: {
            borderColor: palette.neutralTertiary,
            item: {
                default: {
                    backgroundColor: palette.white,
                    borderColor: palette.neutralTertiary,
                    foregroundColor: palette.neutralPrimary
                },
                focussed: {
                    backgroundColor: palette.white,
                    borderColor: palette.themePrimary,
                    foregroundColor: palette.neutralPrimary
                },
                hovered: {
                    backgroundColor: palette.neutralTertiary,
                    borderColor: palette.neutralTertiary,
                    foregroundColor: palette.neutralPrimary
                },
                selected: {
                    backgroundColor: palette.themePrimary,
                    borderColor: palette.themePrimary,
                    foregroundColor: palette.white
                }
            }
        },
        composites: {
            item: {
                borderRadius: borderRadius.sharp,
                borderWidth: `${stroke.none} ${stroke.thin} ${stroke.thin} ${stroke.none}`,
                boxShadow: boxShadow.none
            },
            root: {
                borderRadius: borderRadius.curvedMedium,
                borderWidth: stroke.thin,
                boxShadow: boxShadow.none
            }
        }
    }
}));
